import {Component, ViewEncapsulation} from '@angular/core';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {MatIcon} from '@angular/material/icon';
import {EsvgFiles} from 'frontier';
import {TabActivatedDirective} from 'frontier/browserkit/src/lib/directives/tab-activated.directive';
import {TariffGroupsComponent} from './tariff-groups/tariff-groups.component';
import {TariffTypesComponent} from './tariff-types/tariff-types.component';
import {TariffKeysComponent} from './tariff-keys/tariff-keys.component';

@Component({
  selector: 'app-tariff-options',
  templateUrl: './tariff-options.component.html',
  styleUrl: './tariff-options.component.scss',
  standalone: true,
  imports: [
    MatTab,
    MatTabContent,
    MatTabGroup,
    MatTabLabel,
    MatIcon,
    TariffGroupsComponent,
    TariffTypesComponent,
    TariffKeysComponent,
    TabActivatedDirective,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TariffOptionsComponent {
  protected readonly EsvgFiles = EsvgFiles;
}
